<template>
  <div class="m-container">
    <m_header></m_header>
<!--    <div style="height: 550px;margin: 0 100px;min-width: 1300px;">-->
<!--      <img src="../assets/img/banner.jpg" style="width: 100%; height: 100%;object-fit: cover;" alt="">-->
<!--    </div>-->
<!--    <div style="display: flex;align-items: center; justify-content: center;margin-top: 20px;">-->
<!--      <div style="width: 400px;border: 1px solid #ddd;">-->
<!--        <a href="#"><img src="../assets/img/chubanwu.jpg" width="400" alt=""/></a>-->
<!--      </div>-->
<!--      <div style="width: 100px;"></div>-->
<!--      <div style="width: 400px;border: 1px solid #ddd;">-->
<!--        <a href="#"><img src="../assets/img/lsjz_yingyezhizhao.jpg" width="400" alt=""/></a>-->
<!--      </div>-->
<!--    </div>-->
    <div class="m-content" style="margin: 30px 100px;">
      <div style="display: flex;">
        <div class="m-content-left">
          <div class="m-content-left-tit">分类</div>
          <div class="m-content-left-ul">
            <div @click="toIs2()">高分好书</div>
            <div @click="toIs()">家具用品</div>
            <div @click="toIs()">家居摆件</div>
            <div @click="toIs()">墙饰壁饰</div>
          </div>
        </div>
        <div class="m-content-right" style="margin-top: 40px;">
          <div class="m-content-wrap">
            <div v-if="listType === '1'" v-for="item in dataList2" :key="item.id" @click="toPage(item.id)" class="m-content-item">
              <div class="m-box-img">
                <img :src="item.img" alt="">
              </div>
              <div class="m-box-title">{{item.title}}</div>
              <div class="m-box-number">数量：{{ item.number }}</div>
              <div class="m-box-money">价格：￥{{ item.money }}</div>
            </div>
            <div v-if="listType === '2'" v-for="item in dataList" :key="item.id" @click="toPage(item.id)" class="m-content-item">
              <div class="m-box-img">
                <img :src="item.img" alt="">
              </div>
              <div class="m-box-title">{{item.title}}</div>
              <div class="m-box-number">数量：{{ item.number }}</div>
              <div class="m-box-money">价格：￥{{ item.money }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      listType: '1',
      dataList: [
        {id: '1', img: require('../assets/img/book1.jpg'), title: '黄铜猪摆件白菜猪家居客厅玄关办公室摆设生肖猪店铺乔迁开业礼品', number: 89, money: 544.2},
        {id: '2', img: require('../assets/img/book2.jpg'), title: '新中式柿柿如意铜件摆件黄铜万事葫芦事事办公室老板桌面高档大气', number: 59, money: 539.9},
        {id: '3', img: require('../assets/img/book3.jpg'), title: '中式禅意循环流水喷泉招财摆件客厅办公室桌面雾化加湿器开业礼品', number: 69, money: 539},
        {id: '4', img: require('../assets/img/book4.jpg'), title: '招财陶瓷猫摆件创意可爱猫咪吉祥物家居办公桌面装饰工艺品礼品', number: 49, money: 532},
        {id: '5', img: require('../assets/img/book5.jpg'), title: '北欧客厅流沙漏画玄关鹿摆件电视柜酒柜结婚搬家平安喜乐乔迁礼品', number: 89, money: 558},
        {id: '6', img: require('../assets/img/book6.jpg'), title: '全铜梅花鹿摆件 长辈领导送礼居酒柜装饰品客厅玄关新中式工艺品', number: 79, money: 848},
        {id: '7', img: require('../assets/img/book7.jpg'), title: '大吉大利黄铜工艺品大公鸡铜摆件中式客厅玄关装饰品开业礼品刻字', number: 39, money: 936.2},
        {id: '8', img: require('../assets/img/book8.jpg'), title: '从文实木衣柜卧室家用现代简约挂衣柜收纳柜简易组装儿童衣橱定制', number: 59, money: 2638},
        {id: '9', img: require('../assets/img/book9.jpg'), title: '实木衣柜家用卧室出租房屋用推拉门衣橱宝宝儿童新款民宿收纳柜子', number: 89, money: 3320},
        {id: '10', img: require('../assets/img/book10.jpg'), title: '分段式烤漆大衣柜家用卧室衣橱小户型简约现代亮光对开门储物柜子', number: 89, money: 2349},
        {id: '11', img: require('../assets/img/book11.jpg'), title: '意式极简罗奇堡沙发写意空间设计师创意直排大小户型简约布艺沙发', number: 49, money: 2459},
        {id: '12', img: require('../assets/img/book12.jpg'), title: '新中式乌金木沙发全实木现代中式客厅简约布艺储物小户型实木沙发', number: 29, money: 15668},
        {id: '13', img: require('../assets/img/book13.jpg'), title: '沙发磨砂布真皮磨砂皮侘寂风沙发意大利巧克力意式极简沙发', number: 69, money: 4359.3},
        {id: '14', img: require('../assets/img/book14.jpg'), title: '新中式电表箱遮挡挂画配电箱电闸盒装饰画餐厅墙面客厅免打孔壁画', number: 99, money: 1699},
        {id: '15', img: require('../assets/img/book15.jpg'), title: '百特好个性创意上上签装饰画进门玄关挂画书房办公桌斗柜墙画壁', number: 49, money: 359.8},
        {id: '16', img: require('../assets/img/book16.jpg'), title: '八骏图马到成功墙壁画客厅挂画山水画新中式装饰画办公室国画', number: 89, money: 739.8},
        {id: '17', img: require('../assets/img/book17.jpg'), title: '意式简约现代黑色岩板餐桌椅组合长方形复古小户型侘寂风家用餐桌', number: 29, money: 2342},
        {id: '18', img: require('../assets/img/book18.jpg'), title: '全托底板依诺岩板餐桌亮光纯白家用小户型极简轻奢家庭饭桌桌子', number: 39, money: 2559.8},
        {id: '19', img: require('../assets/img/book19.jpg'), title: '实木奶油风岩板餐桌椅小户型现代简约原木长方形桌吃饭桌轻奢桌子', number: 89, money: 1859.8},
        {id: '20', img: require('../assets/img/book20.jpg'), title: '仿真樱花树大型室内装饰假树 网红许愿树 客厅商场影楼落地摆设', number: 49, money: 569.8},
        {id: '21', img: require('../assets/img/book21.jpg'), title: '轻奢现代高档仿真花假花摆设KTV包厢客厅餐桌装饰品干花插花摆件', number: 69, money: 539.8},
        {id: '22', img: require('../assets/img/book22.jpg'), title: '风原创手扎假花花束仿真花装饰摆件高级仿生花餐桌花摆花绢花', number: 79, money: 589.8},
        {id: '23', img: require('../assets/img/book23.jpg'), title: '仿真红色桃花树大型室内外装饰新年红包许愿树树网红发财树摆件', number: 49, money: 569.8},
        {id: '24', img: require('../assets/img/book24.jpg'), title: '代简约双人床出租房用经济型1.2m单人带软包床架', number: 69, money: 3559.8}
      ],
      dataList2: [
        {id: '25', img: require('../assets/img/book25.jpg'), title: '效率倍增', number: 89, money: 44.2},
        {id: '26', img: require('../assets/img/book26.jpg'), title: '绩效考核', number: 59, money: 49.9},
        {id: '27', img: require('../assets/img/book27.jpg'), title: '我能做销售吗', number: 69, money: 39},
        {id: '28', img: require('../assets/img/book28.jpg'), title: '变量', number: 49, money: 42},
        {id: '29', img: require('../assets/img/book29.jpg'), title: '熟经济', number: 89, money: 58},
        {id: '30', img: require('../assets/img/book30.jpg'), title: '研究的方法', number: 79, money: 48},
        {id: '31', img: require('../assets/img/book31.jpg'), title: '博弈论', number: 39, money: 46.2},
        {id: '32', img: require('../assets/img/book32.jpg'), title: '学习究竟是什么', number: 59, money: 68},
        {id: '33', img: require('../assets/img/book33.jpg'), title: '量子力学', number: 89, money: 52.9},
        {id: '34', img: require('../assets/img/book34.jpg'), title: '博弈论究竟是什么', number: 89, money: 44},
        {id: '35', img: require('../assets/img/book35.jpg'), title: '科学思考者', number: 49, money: 59},
        {id: '36', img: require('../assets/img/book36.jpg'), title: '自我的诞生', number: 29, money: 68},
        {id: '37', img: require('../assets/img/book37.jpg'), title: '组织行为学讲义', number: 69, money: 45.3},
        {id: '38', img: require('../assets/img/book38.jpg'), title: '变革的方法', number: 99, money: 69},
        {id: '39', img: require('../assets/img/book39.jpg'), title: '香帅财富报告', number: 49, money: 59.8},
        {id: '40', img: require('../assets/img/book40.jpg'), title: '创业第一年', number: 89, money: 59.8},
        {id: '41', img: require('../assets/img/book41.jpg'), title: '大卖', number: 29, money: 52},
        {id: '42', img: require('../assets/img/book42.jpg'), title: '懂心理学的妈妈', number: 39, money: 59.8},
        {id: '43', img: require('../assets/img/book43.jpg'), title: '碳金融市场的定价与价格运行机制研究', number: 89, money: 59.8},
        {id: '44', img: require('../assets/img/book44.jpg'), title: '自卑与尴尬', number: 49, money: 59.8}
      ]
    }
  },
  created () {
  },
  methods: {
    toIs2 () {
      this.listType = '1'
    },
    toIs () {
      this.listType = '2'
      this.dataList = this.shuffledList()
    },
    shuffledList () {
      let shuffled = [...this.dataList]
      for (let i = shuffled.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
      }
      return shuffled
    },
    toPage (id) {
      this.$router.push({
        name: 'subclass',
        params: {
          id: id
        }
      })
    },
    toInfoPage (type) {
      this.optionIndex = type
    },
    toZiXunPage (id) {
      this.$router.push({
        name: 'subclassZiXun',
        params: {
          id: id
        }
      })
    }
  },
  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue